import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Context } from "../../Reducers/Store";
import Loading from "../../components/Loading";

export default function Dashboard() {
  const [state] = useContext(Context);
  const [dashboard, setDashboard] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const isSistema = state?.profile?.tipo_usuario === "Sistema";

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API}/dashboard`)
      .then((res) => {
        setDashboard(res.data.data);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const getCards = () => {
    if (!dashboard) return [];

    if (isSistema) {
      return [
        { 
          title: "Contas", 
          value: dashboard.quantidadeContas,
          icon: "building",
          color: "bg-blue-500",
          link: "/contas"
        },
        { 
          title: "Usuários Ativos", 
          value: dashboard.quantidadeUsuariosAtivos,
          icon: "users",
          color: "bg-green-500",
          link: "/usuarios?escopo=todos&status=ativo"
        },
        { 
          title: "Usuários Inativos", 
          value: dashboard.quantidadeUsuariosInativos,
          icon: "user-off",
          color: "bg-gray-500",
          link: "/usuarios?escopo=todos&status=inativo"
        },
      ];
    }

    return [
      { 
        title: "Clientes", 
        value: dashboard.quantidadeClientes,
        icon: "building",
        color: "bg-blue-500",
        link: "/clientes"
      },
      { 
        title: "Expiram essa semana", 
        value: dashboard.certificadosExpiramEssaSemana,
        icon: "alert",
        color: "bg-red-500",
        link: "/certificados?expiracao=semana"
      },
      { 
        title: "Expiram em 30 dias", 
        value: dashboard.certificadosExpiramEm30Dias,
        icon: "clock",
        color: "bg-yellow-500",
        link: "/certificados?expiracao=30dias"
      },
    ];
  };

  const handleCardClick = (link) => {
    if (link) {
      navigate(link);
    }
  };

  if (loading) {
    return (
      <Loading />
    );
  }

  const cards = getCards();

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-2xl font-semibold text-slate-800">Dashboard</h1>
        <p className="text-sm text-slate-500">
          {isSistema 
            ? "Visão geral do sistema" 
            : "Visão geral da sua conta"}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {cards.map((card) => (
          <div 
            key={card.title} 
            onClick={() => handleCardClick(card.link)}
            className="bg-white rounded-xl shadow border p-6 hover:shadow-lg transition cursor-pointer"
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-500">{card.title}</p>
                <p className="text-3xl font-bold text-slate-800 mt-1">{card.value}</p>
              </div>
              <div className={`p-3 rounded-lg ${card.color}`}>
                {card.icon === "building" && (
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                )}
                {card.icon === "users" && (
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                )}
                {card.icon === "user-off" && (
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
                  </svg>
                )}
                {card.icon === "alert" && (
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                  </svg>
                )}
                {card.icon === "clock" && (
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}